import React from 'react'
import { Link } from 'react-router-dom'

const AdminSidebar = ({activeTab}) => {
    return (
        <div className='admin__sidebar'>
            <Link to='/admin/dashboard'>
                <div className={`${activeTab===1 ? "sActive" : ""} sidebar__row`}>
                    <span><svg className="w-8 h-8 text-gray-600 hover:text-gray-800" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 8v8m-4-5v5m-4-2v2m-2 4h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"></path></svg></span>
                    <span className="hover:text-gray-800">Dashboard</span>
                </div>
            </Link>
            <hr className="border-b border-gray-200" />
            <Link to='/admin/categories'>
                <div className={`${activeTab===2 ? "sActive" : ""} sidebar__row`}>
                    <span><svg className="w-8 h-8 text-gray-600 hover:text-gray-800" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 10h18M3 14h18m-9-4v8m-7 0h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"></path></svg></span>
                    <span className="hover:text-gray-800">Categories</span>
                </div>
            </Link>
            <hr className="border-b border-gray-200" />

            <Link to='/admin/products'>
                <div className={`${activeTab===3 ? "sActive" : ""} sidebar__row`}>
                <span><svg className="w-8 h-8 text-gray-600 hover:text-gray-800" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4"></path></svg></span>
                <span className="hover:text-gray-800">Products</span>
            </div>
            </Link>
            <hr className="border-b border-gray-200" />

            <Link to='/admin/orders'>
                <div className={`${activeTab===4 ? "sActive" : ""} sidebar__row`}>
                    <span><svg className="w-8 h-8 text-gray-600 hover:text-gray-800" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"></path></svg></span>
                    <span className="hover:text-gray-800">Orders</span>
                </div>
            </Link>
            <hr className="border-b border-gray-200" />
        </div>
    )
}

export default AdminSidebar